<template>
  <div id="app">
    <step-transition>
      <component
        :is="currentStep"
        :key="currentStep">
      </component>
    </step-transition>
  </div>
</template>

<script>
import StepTransition from '@shared/components/StepTransition'
import { mapGetters } from 'vuex'

import Intro from './views/Intro'
import SigleQuizz from './views/SigleQuizz'
import QuizzOutro from './views/QuizzOutro'
import GapFill1 from './views/GapFill1'
import GapFill2 from './views/GapFill2'
import scrollHelper from '@shared/utils/scrollHelper'

export default {
  name: 'App',
  components: {
    StepTransition,
    intro: Intro,
    sigleQuizz: SigleQuizz,
    quizzOutro: QuizzOutro,
    gapFill1: GapFill1,
    gapFill2: GapFill2
  },
  computed: {
    ...mapGetters(['currentStep'])
  },
  mounted () {
    this.$store.dispatch('init')
    scrollHelper.init()
  }
}
</script>

<style lang="scss">
  @import "../shared/styles/globals";
</style>
